import React, { useState } from 'react';
import Icon from 'components/AppIcon';

const RecentActivity = ({ activities }) => {
  const [activeTab, setActiveTab] = useState('all');


  const tabs = [
    { id: 'all', label: 'All Activity', count: activities.length },
    { id: 'login', label: 'Login', count: activities.filter(a => a.type === 'login').length },
    { id: 'scan', label: 'Scan', count: activities.filter(a => a.type === 'scan').length },
  ];

  const filteredActivities = activeTab === 'all'
    ? activities
    : activities.filter(activity => activity.type === activeTab);

  const getColorClasses = (color) => {
    switch (color) {
      case 'success':
        return { bg: 'bg-success-100', icon: '#27ae60' };
      case 'warning':
        return { bg: 'bg-warning-100', icon: '#f39c12' };
      case 'error':
        return { bg: 'bg-error-100', icon: '#e74c3c' };
      case 'secondary':
        return { bg: 'bg-secondary-100', icon: '#4a90a4' };
      default:
        return { bg: 'bg-primary-100', icon: '#1e3a5f' };
    }
  };

  const formatTimestamp = (utctimestamp) => {
    const timestamp = new Date(utctimestamp)
    const now = new Date();
    const diff = now - timestamp;
    const minutes = Math.floor(diff / 60000);
    const hours = Math.floor(diff / 3600000);
    const days = Math.floor(diff / 86400000);

    if (minutes < 60) {
      return `${minutes} min ago`;
    } else if (hours < 24) {
      return `${hours} hour${hours > 1 ? 's' : ''} ago`;
    } else {
      return `${days} day${days > 1 ? 's' : ''} ago`;
    }
  };

  return (
    <div className="bg-surface rounded-lg border border-border">
      {/* Header */}
      <div className="p-6 border-b border-border">
        <div className="flex items-center justify-between">
          <div>
            <h3 className="text-lg font-heading font-semibold text-text-primary">Recent Activity</h3>
            <p className="text-sm text-text-secondary">Latest updates and transactions</p>
          </div>
          <div className="flex items-center space-x-2">
            <button className="p-2 rounded-lg hover:bg-background nav-transition">
              <Icon name="Filter" size={16} color="#7f8c8d" />
            </button>
            <button className="p-2 rounded-lg hover:bg-background nav-transition">
              <Icon name="MoreHorizontal" size={16} color="#7f8c8d" />
            </button>
          </div>
        </div>
      </div>

      {/* Tabs */}
      <div className="px-6 pt-4">
        <div className="flex flex-wrap space-x-1 bg-background rounded-lg p-1">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`
                flex-1 px-3 py-2 text-sm font-medium rounded-md nav-transition
                ${activeTab === tab.id
                  ? 'bg-surface text-text-primary shadow-sm'
                  : 'text-text-secondary hover:text-text-primary'
                }
              `}
            >
              <span>{tab.label}</span>
              <span className={`
                ml-2 px-2 py-0.5 text-xs rounded-full
                ${activeTab === tab.id
                  ? 'bg-primary-100 text-primary' : 'bg-background text-text-secondary'
                }
              `}>
                {tab.count}
              </span>
            </button>
          ))}
        </div>
      </div>

      {/* Activity List */}
      <div className="p-6">
        <div className="space-y-4 max-h-96 overflow-y-auto">
          {filteredActivities.map((activity,index) => {
            const colors = getColorClasses(activity.color);
            return (
              <div key={`${index}-${activity.id}`} className="flex items-start space-x-4 p-3 rounded-lg hover:bg-background nav-transition">
                <div className={`w-10 h-10 ${colors.bg} rounded-lg flex items-center justify-center flex-shrink-0`}>
                  <Icon name={activity.icon} size={20} color={colors.icon} />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-start justify-between">
                    <div className="flex-1">
                      <h4 className="text-sm font-medium text-text-primary">{activity.title}</h4>
                      <p className="text-sm text-text-secondary mt-1">{activity.description}</p>
                      <div className="flex items-center space-x-3 mt-2">
                        <span className="text-xs text-text-secondary">{formatTimestamp(activity.date)}</span>
                        <span className="text-xs text-text-secondary">by {activity.userId}</span>
                      </div>
                    </div>
                    <button className="p-1 rounded hover:bg-primary-100 nav-transition">
                      <Icon name="MoreVertical" size={14} color="#7f8c8d" />
                    </button>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        {filteredActivities.length === 0 && (
          <div className="text-center py-8">
            <div className="w-16 h-16 bg-background rounded-full flex items-center justify-center mx-auto mb-4">
              <Icon name="Activity" size={24} color="#7f8c8d" />
            </div>
            <p className="text-text-secondary">No recent activity found</p>
          </div>
        )}

        {/* View All Button */}
        {filteredActivities.length > 0 && (
          <div className="mt-6 pt-4 border-t border-border">
            <button className="w-full text-center text-sm text-secondary hover:text-secondary-700 nav-transition font-medium">
              View all activity
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default RecentActivity;